export enum SearchCompareOption {
    Equal = 0,
    Contains = 1,
    StartsWith = 2,
    EndsWith = 3,
    GreaterThan = 4,
    GreaterThanOrEqual = 5,
    LessThan = 6,
    LessThanOrEqual = 7,
}

export const SearchCompareLabel: Record<SearchCompareOption, string> = {
    [SearchCompareOption.Equal]: "Equal",
    [SearchCompareOption.Contains]: "Contains",
    [SearchCompareOption.StartsWith]: "Starts With",
    [SearchCompareOption.EndsWith]: "Ends With",
    [SearchCompareOption.GreaterThan]: "Greater Than",
    [SearchCompareOption.GreaterThanOrEqual]: "Greater Than Or Equal",
    [SearchCompareOption.LessThan]: "Less Than",
    [SearchCompareOption.LessThanOrEqual]: "Less Than Or Equal",
};